const yet = [
    {
        path: '/adminlogin',
        component: ()=>import('../v/login.vue')
    },
    {
        path: '/admin',
        // name: 'Admin',
        component: ()=>import('../v/admin_layout.vue'),
        // beforeEnter: (from,to,next)=>{
        //     console.log(from,to);
        //     if(store.state.login.user){
        //         next()
        //     }
        //     else{
        //         route.push("/adminlogin")
        //     }
        // },
        children: [
            {
                path: '',
                component: ()=>import('../v/admin_welcome.vue')
            },
            {
                path: 'scaffold/list/:id',
                component: ()=>import('../v/autolist.vue')
            },
            {
                path: 'scaffold/form/:id',
                component: ()=>import('../v/autoform.vue')
            },
            {
                path: 'test',
                component: ()=>import('../v/test.vue')
            }
        ]
    }
]
export default yet;

/*

* 修改 /router/index.js
* 文件顶部添加:

import yet from '../yet/r/default.js'

* 修改 const routes 为 

var routes

* 在routes定义后增加

.concat(yet)



*/